import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./store/index.ts";
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from "./components/ErrorBoundary/index.tsx";
import { initSentry } from "./config/sentry.ts";

// Initialize Sentry error monitoring
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ReduxProvider store={store}>
        <BrowserRouter basename="/">
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </BrowserRouter>
      </ReduxProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
